import { AxiosPromise } from 'axios'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
import type {
  GetTagListParams,
  UpdateTagParams,
  TagListItem,
  TagGroupListItem,
  TagListModel,
  TagGroupListModel,
} from './type'

// 标签值列表
export function getTagList(
  params: GetTagListParams,
): AxiosPromise<TagListModel> {
  return request({
    url: v2Host + '/asset/tag/list',
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 标签组列表
export function getTagGroupList(
  params: GetTagListParams,
): AxiosPromise<TagGroupListModel> {
  return request({
    url: v2Host + '/asset/tag-group/list',
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 删除标签值
export function delTag(data: { ids: string }): AxiosPromise {
  return request({
    url: v2Host + '/asset/tag/del',
    method: 'post',
    data: data,
  })
}

// 批量操作标签值
export function updateTag(params: UpdateTagParams): AxiosPromise {
  return request({
    url: v2Host + '/asset/tag/update',
    method: 'post',
    params,
  })
}

// 新增、修改标签值
export function saveTag(data: TagListItem): AxiosPromise {
  return request({
    url: v2Host + '/asset/tag/save',
    method: 'post',
    data: data,
  })
}

// 删除标签组
export function delTagGroup(data: { id: string }): AxiosPromise {
  return request({
    url: v2Host + '/asset/tag-group/del',
    method: 'post',
    data: data,
  })
}

// 新增、修改标签组
export function saveTagGroup(data: TagGroupListItem): AxiosPromise {
  return request({
    url: v2Host + '/asset/tag-group/save',
    method: 'post',
    data: data,
  })
}
